export default __webpack_public_path__ + "static/media/birdquiz.be6602a1.png";